function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sf-button-arrow .a{fill:#EFAD0F;}.sf-button-arrow .b{fill:#101D41;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1375 2115) rotate(180)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 40,
  height: 40,
  transform: "translate(1335 2075)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1348.846 2105.572) rotate(-135)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.465)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 1.477,
  height: 11.121,
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 1.477,
  height: 11.121,
  transform: "translate(0 11.121) rotate(-90)"
}))));

var SvgButtonArrow = function SvgButtonArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "sf-button-arrow",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buttonArrow.05fc1352.svg";
export { ForwardRef as ReactComponent };